import { render, staticRenderFns } from "./userRoleDetailCE.vue?vue&type=template&id=2a485b18&"
import script from "./userRoleDetailCE.vue?vue&type=script&lang=js&"
export * from "./userRoleDetailCE.vue?vue&type=script&lang=js&"
import style0 from "./userRoleDetailCE.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports